<template lang="pug">
#home
  vheader
  mobile-nav
  entry
  footer-user
  vfooter
</template>

<script>
import Vheader from '../components/Vheader.vue'
import MobileNav from '../components/mobile/Nav.vue'
import Entry from '../components/Entry.vue'
import FooterUser from '../components/FooterUser.vue'
import Vfooter from '../components/Vfooter.vue'

export default {
  name: 'app',
  components: {
    Vheader,
    Entry,
    Vfooter,
    FooterUser,
    MobileNav
  }
}
</script>

<style lang="stylus">
#home
  width 100%
  // height 100%
</style>



// WEBPACK FOOTER //
// Entry.vue?c2d95d56